
import Vue from 'vue'

export default Vue.extend({
  name: 'MobileHeaderSubmenu',
  inject: ['provider'],
  props: {
    section: {
      type: Object,
      required: true,
      default: () => { return {} }
    },
    parentCode: {
      type: String,
      required: true,
      default: ''
    },
    parentUrl: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
    visibleMobileMenuCode () {
      return this.provider?.visibleMobileMenuCode
    }
  },
  methods: {
    openMenu (code: string) {
      this.$emit('openMenu', code)
    },
    closeMenu () {
      this.$emit('closeMenu')
    }
  }
})
